import { Component, ErrorInfo, ReactNode } from "react";
import { updateToastMessage, notifyToastError } from "lib/toastUtils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import isEqual from "lodash/isEqual";
interface Props {
  children?: ReactNode;
  refreshWith?: any;
}

interface State {
  hasError: boolean;
  errorText: string;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    errorText: "Ha ocurrido un error",
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorText: "Ha ocurrido un error" };
  }

  public componentDidUpdate(prevProps: any) {
    const { hasError, errorText } = this.state;
    const { refreshWith } = this.props;
    if (hasError && refreshWith && !isEqual(refreshWith, prevProps.refreshWith)) {
      setTimeout(() => this.setState({ hasError: false }));
      updateToastMessage(errorText, { autoClose: 50 });
    }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    notifyToastError(error.message);
    // console.error("Uncaught error: ", error);
    // console.warn("Error Info:", errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <>
          <h1>{this.state.errorText}</h1>
          <ToastContainer />
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

// /* eslint-disable no-console */
// import React, { Component, ErrorInfo, ReactNode } from "react";
// import isEqual from "lodash/isEqual";
// import { updateToastMessage, notifyToastError } from "lib/toastUtils";

// interface Props {
//   children?: ReactNode;
//   refreshWith: any;
// }

// interface State {
//   hasError: boolean;
//   errorText: string;
// }

// class ErrorBoundary extends Component<Props, State> {
//   public state: State = {
//     hasError: false,
//     errorText: "Ha ocurrido un error",
//   };
//   static getDerivedStateFromError() {
//     // Update state so the next render will not render the broken tree.
//     return { hasError: true };
//   }

//   componentDidUpdate(prevProps: any) {
//     const { hasError, errorText } = this.state;
//     const { refreshWith } = this.props;
//     if (hasError && refreshWith && !isEqual(refreshWith, prevProps.refreshWith)) {
//       setTimeout(() => this.setState({ hasError: false }));
//       updateToastMessage(errorText, { autoClose: 50 });
//     }
//   }

//   componentDidCatch(error: any, info: any) {
//     notifyToastError(this.state.errorText);
//     // TODO: log the error to APM or something
//     console.error(error);
//     console.warn(info);
//   }

//   render() {
//     const { hasError } = this.state;
//     const { children } = this.props;
//     if (hasError) {
//       // You can render any custom fallback UI
//       return <div></div>;
//     }

//     return children;
//   }
// }

// export default ErrorBoundary;
